import React from "react";
import { Button } from "semantic-ui-react";
import { useAnnotationsToggle } from "../../hooks";

const AnnotationToggleButton = () => {
  const { showAnnotations, toggleAnnotations } = useAnnotationsToggle();
  return (
    <Button className="ui compact button" onClick={() => toggleAnnotations()}>
      {showAnnotations ? "Hide Annotations" : "Show Annotations"}
    </Button>
  );
};

export default AnnotationToggleButton;
